module.exports = __webpack_public_path__ + "static/banner-two-main-img-b98d88d77fc6dbdbb0baaf8395c7c8fa.png";